import React, { useRef } from 'react';
import { useContainerHeightVar } from '../Formative/containerHeight';
import DialogPrompt from './DialogPrompt';
import DialogStudentTurn from './DialogStudentTurn';

export const DIALOG_HEIGHT_VAR = '--dlg-h';

const DialogDisplay = ({
  repeatButtonEnabled,
  showRepeatButton,
  showMicrophone,
  showPauseOverlay,
  showCheckmarkOverlay,
  showTimer,
  showStudentTurn,
  showPrompt,
  onClickRepeat,
  fakeActiveListeningStatus,
  transcript,
  submitTimerElapsed,
  getNoSubmitTimeout,
  promptText,
  assessment,
  submitButton,
}) => {
  const containerRef = useRef(null);
  useContainerHeightVar(containerRef, DIALOG_HEIGHT_VAR);

  return (
    <div className="dialogDisplay" ref={containerRef}>
      <DialogPrompt
        promptText={promptText}
        showPrompt={showPrompt}
        showRepeatButton={showRepeatButton}
        repeatButtonEnabled={repeatButtonEnabled}
        onClickRepeat={onClickRepeat}
        assessment={assessment}
      />
      <DialogStudentTurn
        showStudentTurn={showStudentTurn}
        showTimer={showTimer}
        showMicrophone={showMicrophone}
        showPauseOverlay={showPauseOverlay}
        showCheckmarkOverlay={showCheckmarkOverlay}
        fakeActiveListeningStatus={fakeActiveListeningStatus}
        transcript={transcript}
        submitTimerElapsed={submitTimerElapsed}
        getNoSubmitTimeout={getNoSubmitTimeout}
      />
      {submitButton && <div className="dialogDisplay__cta">{submitButton}</div>}
    </div>
  );
};

export default DialogDisplay;
